import { render, staticRenderFns } from "./Input.vue?vue&type=template&id=b2070b5e&scoped=true"
import script from "./Input.vue?vue&type=script&lang=js"
export * from "./Input.vue?vue&type=script&lang=js"
import style0 from "./Input.vue?vue&type=style&index=0&id=b2070b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2070b5e",
  null
  
)

export default component.exports